// Original version https://github.com/Swizec/web-session-counter
// MIT License, Copyright (c) 2017 Swizec Teller: https://github.com/Swizec/web-session-counter/blob/master/LICENSE
// Code modified

import { storageAvailable } from 'common/utils/frontUtils';
import errorHandler from 'common/services/errorHandler';

const canUseLocalStorage = storageAvailable('localStorage');

class WebSessionCounter {
	private listeners: Array<() => void>;

	constructor() {
		this.listeners = [];
	}

	get lastActive() {
		const time = window.localStorage.getItem('user_web_session_last_active');
		if (time) {
			return new Date(time);
		} else {
			return new Date();
		}
	}

	set lastActive(time) {
		window.localStorage.setItem('user_web_session_last_active', time.toISOString());
	}

	update() {
		if (!this.listeners.length) return;
		if (canUseLocalStorage) {
			if (this.isFirstSession() || this.isNewSession()) {
				this.lastActive = new Date();
				this.emitNewSession();
			}
		}
	}

	isFirstSession() {
		return !window.localStorage.getItem('user_web_session_last_active');
	}

	isNewSession() {
		// use definition from https://support.google.com/analytics/answer/2731565?hl=en

		const time = this.lastActive;
		const now = new Date();

		return [
			((now as any) - (time as any)) / 1000 / 60 > 30,
			now.toDateString() !== time.toDateString(),
		].some((b) => b);
	}

	addSessionListener(listener: () => void) {
		this.listeners.push(listener);
		this.update();
	}

	removeSessionListener() {
		this.listeners = [];
	}

	emitNewSession() {
		if (!this.listeners.length) {
			errorHandler.report(`Can't emit an event. No listeners exists.`);
			return;
		}

		const fireCallbacks = (callback: () => void) => {
			callback();
		};

		this.listeners.forEach(fireCallbacks);
	}
}

export default new WebSessionCounter();
